@use '../../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.phone-input {
  // font-size: 14px;
  &:not(:placeholder-shown) + label,
  &:focus + label {
    top: 0;
    font-size: 12px;
    left: 14px;
  }
}

.vertical-center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.focus-color {
  box-shadow: 0px 0px 0px 2px rgba(28, 63, 202, 0.14);
}

.error-focus-color {
  box-shadow: 0px 0px 0px 2px rgba(220, 38, 38, 0.14);
}
